'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
const prefereMenosMovimento = (): boolean => {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};

/**
 * Sobe de 0 até `alvo` com desaceleração cúbica, em `duracaoMs`. Quem pediu
 * menos movimento no sistema recebe o valor final direto — a contagem é
 * decorativa, o número é que importa.
 */
export const useContadorAnimado = (alvo, duracaoMs, t0) => {
  const $ = _c(8);
  const ativo = t0 === undefined ? true : t0;
  let t1;
  if ($[0] !== alvo || $[1] !== ativo) {
    t1 = () => ativo ? 0 : alvo;
    $[0] = alvo;
    $[1] = ativo;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [valor, setValor] = useState(t1);
  let t2;
  let t3;
  if ($[3] !== alvo || $[4] !== ativo || $[5] !== duracaoMs) {
    t2 = () => {
      if (!ativo) {
        setValor(alvo);
        return;
      }
      if (prefereMenosMovimento() || duracaoMs <= 0) {
        setValor(alvo);
        return;
      }
      let frame = 0;
      const inicio = performance.now();
      const animar = agora => {
        const progresso = Math.min(1, (agora - inicio) / duracaoMs);
        const suavizado = 1 - Math.pow(1 - progresso, 3);
        setValor(Math.round(alvo * suavizado));
        if (progresso < 1) {
          frame = requestAnimationFrame(animar);
        }
      };
      frame = requestAnimationFrame(animar);
      return () => cancelAnimationFrame(frame);
    };
    t3 = [alvo, duracaoMs, ativo];
    $[3] = alvo;
    $[4] = ativo;
    $[5] = duracaoMs;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
  return valor;
};